import { Component, OnInit, Injector, ChangeDetectionStrategy } from '@angular/core';
import { encryptData, decryptData, b64EncodeUnicode } from '../../../core/utilities';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponents } from 'src/app/base.component';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
import { ReferenceService } from 'src/app/services/reference.service';

import liff from '@line/liff';
@Component({
    selector: 'app-line-confirm',
    templateUrl: './line-confirm.component.html',
    styleUrls: ['./line-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LineConfirmComponent extends BaseComponents implements OnInit {

  state: string = 'register';
  log_session_text: string = "form-readonly";
  referenceUUID: string | null = null;
  constructor(
    protected injectorObj: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private referenceService:ReferenceService,
    private getMaskingService : GetMaskingService,
  ) { 
    super(injectorObj)
  }

  ngOnInit() {
    console.log('query');
    const funcName = 'ngOnInit';
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `line-confirm`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    this.route.queryParams.subscribe(params => {
      let receive = params['state'];
      this.logger.info(`${this.log_session_text} ${funcName} receive:${JSON.stringify(receive)}`);
      console.log(receive);
      if (receive) {
        this.logger.info(`${this.log_session_text} ${funcName} have receive`);
        this.state = receive;
      }
    });
  }

  onClickConfirme() {
    console.log('confirme line');
    const funcName = 'onClickConfirme';
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const params = {
      update_channel_identity_flag: true
    };
    this.logger.info(`${this.log_session_text} ${funcName} redirectConfirmOTP params:${JSON.stringify(params)}`);
    this.redirectConfirmOTP(params);
  }

  private redirectConfirmOTP(param = null) {
    const funcName = 'redirectConfirmOTP';
    this.logger.info(`${this.log_session_text} ${funcName} start and state:${this.state}`);
    if (this.state == 'register') {
      const params = {
        more: param
      }
      this.logger.info(`${this.log_session_text} ${funcName} state register goto confirm-otp params:${JSON.stringify(params)}`);
      const query = encryptData(b64EncodeUnicode(JSON.stringify(params)));
      this.router.navigate(['../confirm-otp'], { relativeTo: this.route, queryParams: { params: query } });
    } else {
      const params = {
        update_channel_identity_flag: true
      }
      this.logger.info(`${this.log_session_text} ${funcName} state other goto new-user params:${JSON.stringify(params)}`);

      const query = encryptData(b64EncodeUnicode(JSON.stringify(params)));
      this.router.navigate(['../new-user'], { relativeTo: this.route, queryParams: { params: query } });
    }

  }


  redirectToChateRoom() {
    console.log('chate room')
    liff.closeWindow();
  }

}
